/* Willa CRO cart drawer.
   Contract:
     - document.dispatchEvent(new CustomEvent('willa:cart_open'))     → open
     - document.dispatchEvent(new CustomEvent('willa:cart_close'))    → close
     - document.dispatchEvent(new CustomEvent('willa:cart_added'))    → refresh, then open
   Reads /cart.js for live state; mutates via /cart/change.js + /cart/add.js.

   Modules: perk ladder · hold timer · savings · add-a-shade cross-sell · $0 gift line · trust/pay.
*/
(function () {
  "use strict";

  var drawer = document.getElementById("cart-drawer");
  if (!drawer) return;

  var lineTpl   = document.getElementById("cart-drawer-line-tpl");
  var xsellTpl  = document.getElementById("cart-drawer-xsell-tpl");
  var itemsEl   = drawer.querySelector("[data-cart-items]");
  var emptyEl   = drawer.querySelector("[data-cart-empty]");
  var footEl    = drawer.querySelector("[data-cart-foot]");
  var headCount = drawer.querySelector("[data-cart-headcount]");
  var subTotalEl= drawer.querySelector("[data-cart-subtotal]");
  var saveRow   = drawer.querySelector("[data-cart-save-row]");
  var listEl    = drawer.querySelector("[data-cart-list]");
  var savedEl   = drawer.querySelector("[data-cart-saved]");
  var shipNote  = drawer.querySelector("[data-cart-ship-note]");
  var checkoutLbl = drawer.querySelector("[data-cart-checkout-label]");

  // ladder
  var ladder    = drawer.querySelector("[data-cart-ladder]");
  var ladderFill= drawer.querySelector("[data-cart-ladder-fill]");
  var ladderMsg = drawer.querySelector("[data-cart-ladder-msg]");
  var nodeReturns = drawer.querySelector('.cd-node[data-node="returns"]');
  var nodeShip    = drawer.querySelector('.cd-node[data-node="shipping"]');
  var nodeGift    = drawer.querySelector('.cd-node[data-node="gift"]');

  // hold timer
  var holdEl    = drawer.querySelector("[data-cart-hold]");
  var holdTimeEl= drawer.querySelector("[data-cart-hold-time]");

  // cross-sell
  var xsellEl   = drawer.querySelector("[data-cart-xsell]");
  var xsellCards= drawer.querySelector("[data-cart-xsell-cards]");

  // config from data-attrs
  var freeShipThreshold = parseInt(drawer.getAttribute("data-free-ship-threshold") || "7500", 10);
  var giftThreshold     = parseInt(drawer.getAttribute("data-gift-threshold") || "11600", 10);
  var giftVariant       = parseInt(drawer.getAttribute("data-gift-variant") || "0", 10) || 0;
  var holdEnabled       = drawer.getAttribute("data-hold-enabled") === "1";
  var holdMinutes       = parseInt(drawer.getAttribute("data-hold-minutes") || "10", 10);
  var crossSellEnabled  = drawer.getAttribute("data-cross-sell") === "1";
  var singlePrice       = drawer.getAttribute("data-single-price") || "$49";
  var bundlePrice       = drawer.getAttribute("data-bundle-price") || "$29";  // per-pair bundle rate shown on cross-sell
  var tightsUrl         = drawer.getAttribute("data-tights-url") || "/cart";
  var VARIANTS = {}; try { VARIANTS = JSON.parse(drawer.getAttribute("data-variants") || "{}"); } catch (e) {}
  var SHADE_DOTS = {}; try { SHADE_DOTS = JSON.parse(drawer.getAttribute("data-shade-dots") || "{}"); } catch (e) {}

  var openLock  = false;   // re-entry guard for rapid open dispatches
  var holdTimer = null;
  var HOLD_KEY  = "willa_cart_hold_until";

  /* ---------- money ----------
     /cart.js ALREADY returns prices in the cart's presentment currency (e.g.
     HKD under Shopify Markets). We must format those values in that currency
     AS-IS — NOT route them through WillaMoney.fmt, which converts USD→local and
     would double-apply the FX rate (the HK$1,837-instead-of-HK$226 bug). */
  var cartCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
  function money(cents) {
    if (typeof cents !== "number") return "";
    try {
      return new Intl.NumberFormat(navigator.language || "en-US", {
        style: "currency",
        currency: cartCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      var d = cents / 100;
      return (d % 1 === 0) ? "$" + d.toFixed(0) : "$" + d.toFixed(2);
    }
  }

  /* ---------- open / close ---------- */
  function open() {
    drawer.hidden = false;
    drawer.setAttribute("aria-hidden", "false");
    requestAnimationFrame(function () { drawer.classList.add("is-open"); });
    document.body.style.overflow = "hidden";
    startHold();
    var closeBtn = drawer.querySelector("[data-cart-close]");
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function close() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    stopHoldTick();
    setTimeout(function () {
      if (!drawer.classList.contains("is-open")) drawer.hidden = true;
    }, 320);
  }

  function setEmpty(isEmpty) {
    emptyEl.hidden  = !isEmpty;
    itemsEl.hidden  = isEmpty;
    footEl.hidden   = isEmpty;
    if (ladder) ladder.hidden = isEmpty;
    if (holdEl) holdEl.hidden = isEmpty || !holdEnabled;
    if (xsellEl && isEmpty) xsellEl.hidden = true;
  }

  /* ---------- hold timer ---------- */
  function startHold() {
    if (!holdEnabled || !holdEl) return;
    var until = parseInt(sessionStorage.getItem(HOLD_KEY) || "0", 10);
    var now = Date.now();
    if (!until || until < now) {
      until = now + holdMinutes * 60 * 1000;
      try { sessionStorage.setItem(HOLD_KEY, String(until)); } catch (e) {}
    }
    tickHold();
    stopHoldTick();
    holdTimer = setInterval(tickHold, 1000);
  }
  function resetHold() {
    try { sessionStorage.removeItem(HOLD_KEY); } catch (e) {}
  }
  function stopHoldTick() { if (holdTimer) { clearInterval(holdTimer); holdTimer = null; } }
  function tickHold() {
    if (!holdTimeEl) return;
    var until = parseInt(sessionStorage.getItem(HOLD_KEY) || "0", 10);
    var left = Math.max(0, Math.round((until - Date.now()) / 1000));
    var m = Math.floor(left / 60), s = left % 60;
    holdTimeEl.textContent = (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
    if (left <= 0) stopHoldTick();
  }

  /* ---------- perk ladder ---------- */
  function renderLadder(payable, hasGiftLine) {
    if (!ladder) return;
    // span runs from 0 → gift threshold; shipping node sits at its real fraction
    var span = Math.max(giftThreshold, freeShipThreshold, 1);
    var pct = Math.min(100, Math.round((payable / span) * 100));
    if (ladderFill) ladderFill.style.width = pct + "%";

    var shipUnlocked = payable >= freeShipThreshold;
    var giftUnlocked = payable >= giftThreshold;

    setNode(nodeReturns, true);
    setNode(nodeShip, shipUnlocked);
    setNode(nodeGift, giftUnlocked);

    // place the shipping node at its real position along the track
    if (nodeShip && nodeShip.parentNode) {
      var shipFrac = Math.min(100, Math.round((freeShipThreshold / span) * 100));
      nodeShip.style.setProperty("--node-pos", shipFrac + "%");
    }

    if (ladderMsg) {
      if (giftUnlocked) {
        ladderMsg.textContent = hasGiftLine ? "Free wash bag added — every perk unlocked."
                                            : "Every perk unlocked.";
      } else if (shipUnlocked) {
        ladderMsg.innerHTML = "Add <b>" + money(giftThreshold - payable) + "</b> for your free wash bag.";
      } else {
        ladderMsg.innerHTML = "Add <b>" + money(freeShipThreshold - payable) + "</b> to unlock free shipping.";
      }
    }
  }
  function setNode(node, on) {
    if (!node) return;
    node.classList.toggle("is-on", !!on);
  }

  /* ---------- line items ---------- */
  function renderItems(cart) {
    itemsEl.innerHTML = "";
    cart.items.forEach(function (item) {
      var isGift = giftVariant && item.variant_id === giftVariant;
      var node = lineTpl.content.firstElementChild.cloneNode(true);
      node.dataset.key = item.key;
      if (isGift) node.classList.add("cart-line--gift");

      var img   = node.querySelector("[data-cart-line-img]");
      var giftFlag = node.querySelector("[data-cart-line-gift]");
      var link  = node.querySelector("[data-cart-line-link]");
      var tlink = node.querySelector("[data-cart-line-title-link]");
      var vari  = node.querySelector("[data-cart-line-variant]");
      var qty   = node.querySelector("[data-cart-line-qty]");
      var qtyWrap = node.querySelector(".cart-line__qty");
      var priceNow = node.querySelector("[data-cart-line-price]");
      var priceWas = node.querySelector("[data-cart-line-was]");
      var remove   = node.querySelector("[data-cart-line-remove]");

      if (img) {
        img.src = item.image ? item.image.replace(/(\.(jpg|jpeg|png|webp))/i, "_200x$1") : "";
        img.alt = item.product_title || "";
      }
      if (link)  link.href = item.url || "#";
      if (tlink) { tlink.href = item.url || "#"; tlink.textContent = item.product_title || ""; }
      if (vari)  vari.textContent = (item.options_with_values || [])
        .map(function (o) { return o && o.value; })
        .filter(function (v) { return v && v !== "Default Title"; }).join(" · ");

      if (qty) qty.textContent = String(item.quantity);

      // per-line price + strikethrough when a line-level discount exists
      if (priceNow) priceNow.textContent = isGift ? "Free" : money(item.final_line_price);
      if (priceWas) {
        if (!isGift && item.original_line_price && item.original_line_price > item.final_line_price) {
          priceWas.textContent = money(item.original_line_price);
          priceWas.hidden = false;
        } else { priceWas.hidden = true; }
      }

      // gift line: no qty editing, no manual remove, badge it
      if (isGift) {
        if (giftFlag) giftFlag.hidden = false;
        if (qtyWrap) qtyWrap.style.display = "none";
        if (remove)  remove.style.display = "none";
      }

      itemsEl.appendChild(node);
    });
  }

  /* ---------- cross-sell: shades not yet in the bag ---------- */
  function renderXsell(cart) {
    if (!crossSellEnabled || !xsellEl || !xsellTpl) return;
    var shades = Object.keys(VARIANTS);
    if (!shades.length) { xsellEl.hidden = true; return; }

    // map variant_id → {shade,size}; figure out which shades are present + a size to add
    var idToShade = {};
    shades.forEach(function (sh) {
      Object.keys(VARIANTS[sh]).forEach(function (sz) { idToShade[VARIANTS[sh][sz]] = sh; });
    });

    var present = {};
    var addSize = "M"; // sensible default if we can't read one from the cart
    cart.items.forEach(function (item) {
      var sh = idToShade[item.variant_id];
      if (sh) {
        present[sh] = true;
        var sz = (item.options_with_values || [])
          .map(function (o) { return o && o.value; })
          .filter(function (v) { return VARIANTS[sh] && VARIANTS[sh][v]; })[0];
        if (sz) addSize = sz;
      }
    });

    var missing = shades.filter(function (sh) { return !present[sh]; });
    xsellCards.innerHTML = "";
    if (!missing.length) { xsellEl.hidden = true; return; }

    missing.forEach(function (sh) {
      var vid = VARIANTS[sh] && VARIANTS[sh][addSize];
      if (!vid) return;
      var card = xsellTpl.content.firstElementChild.cloneNode(true);
      card.dataset.variant = vid;
      var dot = card.querySelector("[data-xsell-dot]");
      var title = card.querySelector("[data-xsell-title]");
      var wasEl = card.querySelector("[data-xsell-was]");
      var nowEl = card.querySelector("[data-xsell-now]");
      var sub = card.querySelector("[data-xsell-sub]");
      if (dot) dot.style.background = SHADE_DOTS[sh] || "#1c1c1c";
      if (title) title.textContent = "Add a " + sh + " pair";
      if (wasEl) wasEl.textContent = singlePrice;   // original single-pair price, struck through
      if (nowEl) nowEl.textContent = bundlePrice;    // limited add-on bundle rate
      if (sub) sub.textContent = "Limited: extra pair at the bundle price · Size " + addSize;
      xsellCards.appendChild(card);
    });
    xsellEl.hidden = false;
  }

  /* ---------- main render (PURE display — never mutates the cart) ---------- */
  function render(cart) {
    if (cart && cart.currency) cartCurrency = cart.currency;   // presentment currency from Shopify
    if (!cart || !cart.items || cart.items.length === 0) {
      setEmpty(true);
      updateCount(0);
      return;
    }
    setEmpty(false);
    renderItems(cart);

    // payable = post auto-discount (bundle pricing). Excludes nothing — gift is $0.
    var payable = (typeof cart.total_price === "number") ? cart.total_price
                : (typeof cart.items_subtotal_price === "number") ? cart.items_subtotal_price : 0;
    var list    = cart.items_subtotal_price != null ? cart.items_subtotal_price : payable;
    var saved   = Math.max(0, list - payable);

    subTotalEl.textContent = money(payable);
    if (checkoutLbl) checkoutLbl.textContent = "Secure checkout · " + money(payable);

    if (saved > 0 && saveRow) {
      listEl.textContent = money(list);
      savedEl.textContent = "You saved " + money(saved);
      saveRow.hidden = false;
    } else if (saveRow) { saveRow.hidden = true; }

    if (shipNote) shipNote.hidden = payable < freeShipThreshold;

    var hasGiftLine = giftVariant && cart.items.some(function (i) { return i.variant_id === giftVariant; });
    renderLadder(payable, hasGiftLine);
    renderXsell(cart);
    updateCount(giftVariant
      ? cart.items.reduce(function (n, i) { return n + (i.variant_id === giftVariant ? 0 : i.quantity); }, 0)
      : cart.item_count);
  }

  function updateCount(n) {
    if (headCount) {
      headCount.textContent = String(n);
      headCount.hidden = n <= 0;
    }
    // Show every cart launcher (sticky-bar bag icon, nav cart, …) only when the
    // bag has items. Any element with [data-cart-launcher] participates.
    document.querySelectorAll("[data-cart-launcher]").forEach(function (el) { el.hidden = n <= 0; });
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = String(n);
      el.hidden = n <= 0;
      if (n > 0) el.removeAttribute("hidden");
    });
  }

  /* ---------- serialized cart mutations ----------
     Every cart write funnels through run(): only ONE is ever in flight, the
     drawer is visually locked while it runs, and the server response is
     VALIDATED — a 404/422 never gets rendered as an empty cart; we re-read the
     authoritative /cart.js state instead. After each settled write the $0 gift
     line is reconciled exactly once. This removes the races that previously
     froze the drawer when quantities were edited across the gift/discount
     threshold ("go to 3 items → bugs out → can't add more"). */
  var cartBusy = false;

  function setBusyUI(on) { drawer.classList.toggle("is-busy", !!on); }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // Normalize any /cart write Response into a REAL full cart object.
  //   • /cart/change.js  → returns the full cart   (has item_count) → render directly
  //   • /cart/add.js {items:[…]} → returns ONLY the added items as {items:[…]} —
  //     it has `.items` but NO item_count / total_price. Rendering that as the cart
  //     showed just the added item ("removed everything"), an "undefined" count and
  //     a "$NaN" total. So we key on item_count (full-cart-only) and otherwise
  //     re-read the authoritative /cart.js.
  function toCart(r) {
    if (!r || !r.ok) return fetchCart();
    return r.json().then(function (c) {
      return (c && typeof c.item_count === "number") ? c : fetchCart();
    }).catch(function () { return fetchCart(); });
  }

  // Run a single cart write exclusively. User-initiated calls made while one is
  // already in flight are dropped (the user just clicks again) — this is what
  // kills the double-fire / stale-qty races. Internal calls (the gift) bypass
  // the drop guard because they are only ever scheduled after the queue drains.
  function run(writeFactory, opts) {
    opts = opts || {};
    if (cartBusy && !opts.internal) return Promise.resolve(null);
    cartBusy = true; setBusyUI(true);
    return writeFactory()
      .then(toCart)
      .catch(function () { return fetchCart(); })
      .then(function (cart) {
        cartBusy = false; setBusyUI(false);
        if (cart) {
          render(cart);
          try { document.dispatchEvent(new CustomEvent("willa:cart_updated", { detail: { cart: cart } })); } catch (e) {}
          if (!opts.skipGift) reconcileGift(cart);
        }
        return cart;
      });
  }

  function changeLine(key, qty) {
    return run(function () {
      return fetch("/cart/change.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      });
    });
  }
  function addVariant(id) {
    return run(function () {
      return fetch("/cart/add.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      });
    });
  }
  // Silent re-read (no exclusivity needed) used on open/hydrate.
  function refresh() {
    return fetchCart().then(function (cart) {
      if (cart) {
        render(cart);
        try { document.dispatchEvent(new CustomEvent("willa:cart_updated", { detail: { cart: cart } })); } catch (e) {}
        reconcileGift(cart);
      }
      return cart;
    });
  }

  /* ---------- gift-with-purchase (exactly one reconcile per settled write) ---------- */
  function reconcileGift(cart) {
    if (!giftVariant || !cart || !cart.items) return;
    var payable = (typeof cart.total_price === "number") ? cart.total_price
                : (typeof cart.items_subtotal_price === "number") ? cart.items_subtotal_price : 0;
    var line = cart.items.filter(function (i) { return i.variant_id === giftVariant; })[0];
    var qualifies = payable >= giftThreshold;
    if (qualifies && !line) {
      run(function () {
        return fetch("/cart/add.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: giftVariant, quantity: 1 }] })
        });
      }, { internal: true, skipGift: true });   // skipGift → no add/remove feedback loop
    } else if (!qualifies && line) {
      run(function () {
        return fetch("/cart/change.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        });
      }, { internal: true, skipGift: true });
    }
  }

  /* ---------- delegated events (drop clicks while a write is in flight) ---------- */
  itemsEl.addEventListener("click", function (e) {
    var lineEl = e.target.closest("[data-cart-line]");
    if (!lineEl || cartBusy) return;
    var key = lineEl.dataset.key;
    var qtyEl = lineEl.querySelector("[data-cart-line-qty]");
    var qty = parseInt((qtyEl && qtyEl.textContent) || "1", 10);
    if (e.target.closest("[data-cart-line-inc]"))       changeLine(key, qty + 1);
    else if (e.target.closest("[data-cart-line-dec]"))  changeLine(key, Math.max(0, qty - 1));
    else if (e.target.closest("[data-cart-line-remove]")) changeLine(key, 0);
  });

  if (xsellCards) {
    xsellCards.addEventListener("click", function (e) {
      var card = e.target.closest("[data-xsell-card]");
      if (!card || cartBusy) return;
      var vid = parseInt(card.dataset.variant || "0", 10);
      if (!vid) return;
      card.classList.add("is-adding");
      resetHold(); startHold();
      addVariant(vid).finally(function () { card.classList.remove("is-adding"); });
    });
  }

  /* ---------- checkout: preserve funnel tracking ---------- */
  var checkoutBtn = drawer.querySelector("[data-cart-checkout]");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function () {
      // The PDP no longer fires begin_checkout (the drawer is the interstitial),
      // so fire it here to keep the PostHog / Meta funnel step intact. The link
      // navigates to /checkout natively — don't preventDefault.
      try { document.dispatchEvent(new CustomEvent("willa:begin_checkout", { detail: { source: "cart-drawer" } })); } catch (e) {}
    });
  }

  /* ---------- close handlers ---------- */
  drawer.querySelectorAll("[data-cart-close]").forEach(function (el) { el.addEventListener("click", close); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) close();
  });

  /* ---------- global API ---------- */
  document.addEventListener("willa:cart_open", function () {
    if (openLock) return; openLock = true;
    refresh().finally(function () { open(); openLock = false; });
  });
  document.addEventListener("willa:cart_close", close);
  document.addEventListener("willa:cart_added", function () {
    if (openLock) return; openLock = true;
    resetHold();
    refresh().finally(function () { open(); openLock = false; });
  });

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-cart-open]");
    if (!trigger) return;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent("willa:cart_open"));
  });

  // Initial silent refresh so the nav cart-count hydrates.
  refresh().catch(function () {});
})();
